export interface AddGoalState {
    addGoalData: any[];
    responceStatus: boolean;
    error: null | string;
}


export enum AddGoalTypes {
    FETCH_ADD_GOAL_DATA = "FETCH_ADD_GOAL_DATA",
    FETCH_ADD_GOAL_DATA_SUCCESS = "FETCH_ADD_GOAL_DATA_SUCCESS",
    FETCH_ADD_GOAL_DATA_ERROR = "FETCH_ADD_GOAL_DATA_ERROR",
}

export type AddGoalAction =
    | { type: AddGoalTypes.FETCH_ADD_GOAL_DATA }
    | { type: AddGoalTypes.FETCH_ADD_GOAL_DATA_SUCCESS; payload: any[] }
    | { type: AddGoalTypes.FETCH_ADD_GOAL_DATA_ERROR; payload: string };